/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: '_StoreLocator_PublicTransport_ESpot' },
    { emsName: '_StoreLocator_ParkingOptions_ESpot' },
    { emsName: '_CSD_Footer_Espot' },
    { emsName: '_StoreLocator_Events_ESpot' },
];
export default contentItems;
